export default __webpack_public_path__ + "static/mykola-yanush-964c037d4a8a6de3a6bd0101a75d07d9.jpg";